<template>
  <div class="c-single-select flex flex-col gap-2 pa-2">
    <div
      v-for="(option, index) in options"
      :key="index"
      class="c-single-select__option flex items-center rounded-2 cursor-pointer h-8"
      :class="{ 'c-single-select__option--selected': isSelected(option) }"
      @click="selectOption(option)"
    >
      <CIcon v-if="option.icon" class="ml-2" :icon="option.icon" />
      <span class="ml-2">{{ option.title }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'

interface Option {
  icon: string
  value: string
  title: string
}

const props = defineProps<{
  options: Option[]
  modelValue: string | null
}>()

const emit = defineEmits<(event: 'update:modelValue', value: string) => void>()

const isSelected = (option: Option) => option.value === props.modelValue

const selectOption = (option: Option): void => {
  emit('update:modelValue', option.value)
}
const themeVars = useThemeVars()
</script>

<style scoped>
.c-single-select__option--selected {
  background-color: v-bind('themeVars.primary6');
}
</style>
